import { TrackJS } from "trackjs";
import { GOOGLE_RECAPTCHA_SITE_KEY } from "api_urls";

const getRecaptchaToken = ({ onError, onSuccess }) => {
  const handleRecaptchaError = error => {
    // If Google is down or something goes wrong during the grecaptcha
    // request, send a notification and inform the user about the problem.
    TrackJS.track(`error fetching recaptcha_token from Google: ${error}`);
    onError();
  };

  try {
    /* eslint-disable no-undef */
    grecaptcha.enterprise.ready(function () {
      try {
        grecaptcha.enterprise
          .execute(GOOGLE_RECAPTCHA_SITE_KEY, {
            action: "UG_CREATE_PAYMENT_METHOD",
          })
          .then(function (token) {
            onSuccess(token);
          })
          .catch(error => {
            handleRecaptchaError(error);
          });
      } catch (error) {
        handleRecaptchaError(error);
      }
    });
    /* eslint-enable no-undef */
  } catch (error) {
    handleRecaptchaError(error);
  }
};

const loadGoogleRecaptcha = () => {
  const srcBase = "https://www.google.com/recaptcha/enterprise.js?render=";
  const src = `${srcBase}${GOOGLE_RECAPTCHA_SITE_KEY}`;
  let script = document.querySelector(`[src^='${srcBase}']`);
  if (!script) {
    script = document.createElement("script");
    script.src = src;
    document.querySelector("body").append(script);
  }
};

export { getRecaptchaToken, loadGoogleRecaptcha };
